var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08317 9.41665C7.74984 9.08331 7.24984 9.08331 6.9165 9.41665C6.58317 9.74998 6.58317 10.25 6.9165 10.5833L9.4165 13.0833C9.58317 13.25 9.74984 13.3333 9.99984 13.3333C10.2498 13.3333 10.4165 13.25 10.5832 13.0833L16.4165 6.41665C16.6665 5.99998 16.6665 5.49998 16.2498 5.24998C15.9165 4.99998 15.4165 4.99998 15.1665 5.33331L9.99984 11.25L8.08317 9.41665Z",
    fill: "#02BC7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4998 9.16666C16.9998 9.16666 16.6665 9.49999 16.6665 9.99999C16.6665 13.6667 13.6665 16.6667 9.99984 16.6667C6.33317 16.6667 3.33317 13.6667 3.33317 9.99999C3.33317 8.24999 3.99984 6.58332 5.24984 5.33332C6.49984 3.99999 8.1665 3.33332 9.99984 3.33332C10.4998 3.33332 11.0832 3.41666 11.5832 3.49999C11.9998 3.66666 12.4998 3.41666 12.6665 2.91666C12.8332 2.41666 12.4998 2.08332 12.0832 1.91666H11.9998C11.3332 1.74999 10.6665 1.66666 9.99984 1.66666C5.4165 1.66666 1.6665 5.41666 1.6665 10.0833C1.6665 12.25 2.58317 14.4167 4.08317 15.9167C5.6665 17.5 7.74984 18.3333 9.9165 18.3333C14.4998 18.3333 18.2498 14.5833 18.2498 9.99999C18.3332 9.49999 17.9165 9.16666 17.4998 9.16666Z",
    fill: "#02BC7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark1);
export default __webpack_public_path__ + "static/media/checkmark 1.5739fb5190c6d16265e8a15108260761.svg";
export { ForwardRef as ReactComponent };